var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8592 17.1157L12.8395 5.47413C12.6621 5.17991 12.3436 5 12 5C11.6564 5 11.3379 5.17988 11.1604 5.47413L4.14081 17.1157C3.95825 17.4185 3.95284 17.7961 4.12672 18.104C4.30059 18.4118 4.62675 18.6022 4.98031 18.6022H19.0197C19.3732 18.6022 19.6994 18.4118 19.8733 18.104C20.0471 17.7961 20.0418 17.4185 19.8592 17.1157ZM12.0052 9.02694C12.4084 9.02694 12.7495 9.25438 12.7495 9.65751C12.7495 10.8876 12.6048 12.6553 12.6048 13.8854C12.6048 14.2059 12.2533 14.3402 12.0052 14.3402C11.6745 14.3402 11.3954 14.2058 11.3954 13.8854C11.3954 12.6553 11.2507 10.8876 11.2507 9.65751C11.2507 9.25438 11.5814 9.02694 12.0052 9.02694ZM12.0156 16.6454C11.5608 16.6454 11.2196 16.2733 11.2196 15.8495C11.2196 15.4153 11.5607 15.0535 12.0156 15.0535C12.4394 15.0535 12.8012 15.4153 12.8012 15.8495C12.8012 16.2733 12.4394 16.6454 12.0156 16.6454Z",
    fill: "#D56464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.4be3e2c3273118773091f2e1b31e0476.svg";
export { ForwardRef as ReactComponent };